import React, {useEffect, useState} from 'react'
import {Field, Form, Formik} from "formik";
import useToggle from '../../../../../hooks/UseToggle';
import * as Yup from "yup";
import Swal from "sweetalert2";
import {CampoSelect} from '../../../../../helpers/CampoSelect';
import {createEIR} from '../../../../../helpers/Api';
import PatioVacio from "../../../../../helpers/PatioVacio";
import FileUploader from '../../../../../helpers/FileUploader';
import {AGENTE_ADUANAL_USER} from "../../../../../constants";

export const EIR = ({
  idSolicitud, 
  idContenedor, 
  token,
  closeModal, 
  dataEir,
}) => {

  const role = localStorage.getItem('role');
  const BASE_URL = process.env.REACT_APP_API;

  useEffect(() => {
    dataEir.archivo_eir ? setShowDragZone(false) : setShowDragZone(true);
  }, [])
  
  const [isNavieraTransportation, setIsNavieraTransportation] = useToggle();
  const [dateNow, setDateNow] = useState('')
  const [showDragZone, setShowDragZone] = useState(false);
  const dataEirCounterKey =  dataEir?.archivo_eir.split('/').length - 1
  const dataEirFileRoute = dataEir?.archivo_eir.split('/')[dataEirCounterKey]


 
  let initialValues = {
    "archivo_eir": dataEirFileRoute || "",
    patio_vacio: dataEir?.patio_vacio_id === null ?
        null:
    { value: dataEir?.patio_vacio_id, label: dataEir?.patio_vacio.nombre, },
    otro_patio_vacio: dataEir.otro_patio_vacio || "",
    fecha_entrega: dataEir.fecha_entrega || "",
  };

  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based, add 1 to get the correct month
    const day = String(date.getDate()).padStart(2, '0');
    setDateNow(`${year}-${month}-${day}`)
  }


  const handlerIsSwitchPassWord = () => {
    getCurrentDate();
    setIsNavieraTransportation();
  }

  const handlerCreateEir = async (data, resetForm) => {
    try {
      const response = await createEIR(idSolicitud, idContenedor, 
        !isNavieraTransportation ?
        {
        archivo_eir:  data.archivo_eir,
        patio_vacio_id:   data.patio_vacio.value,
        otro_patio_vacio: data.otro_patio_vacio,
        fecha_entrega: data.fecha_entrega,
       } : 
       {
         transporte_por_naviera: true,
         fecha_entrega: data.fecha_entrega,
         archivo_eir:  data.archivo_eir,
       },
      token);
      if (response) {
        Swal.fire("Exito", "El EIR fue creado con éxito", "success");
        resetForm();
        closeModal();
      }
    } catch (error) {
      Swal.fire("Oops", 
      `Ha surgido un problema al crear el EIR, <br />
          Consejo: ${JSON.stringify(error.response.data)}
      `, 
      "error");
    }
  };

  const downLoadEirDocs = (fileName) => {
    fetch(`${BASE_URL}/media/${fileName}`).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}`;
        a.click();
      });
    });
  };

  return (
    <>
      <Formik
          enableReinitialize="true"
          initialValues={initialValues}
          validationSchema={Yup.object().shape({
            // numero_cuenta: Yup.string().required("Campo requerido"),
            // nombre_banco: Yup.string().required("Campo requerido")
          })}
          onSubmit={(values, { resetForm }) => {
            handlerCreateEir(values, resetForm);
          }}
      >
        {(props) => (
      <Form>
      <div className="row mb-5 d-flex justify-content-center">
      <div className='col-8'>
          <h6>{dataEir.archivo_eir ? 'Esta es la información guardada de la etapa EIR' : 'Ingrese la información requerida referente al EIR' }</h6>
        </div>
        {dataEir.fecha_entrega &&
        <div className='col-8 mt-5 mb-3' >
          <p>Archivo EIR guardado:</p>
          <button className='btn btn-link'
           type='button' 
          onClick={() => downLoadEirDocs(dataEir.archivo_eir)}
          >{dataEirFileRoute}</button>
          {role === AGENTE_ADUANAL_USER  &&
          <button type={"button"} className='btn btn-outline-primary' onClick={() => setShowDragZone(true)} style={{marginLeft: '20px'}}>Sustituir archivo</button>
          }
        </div> 
        }
        { !dataEir.fecha_entrega &&
        <div className='col-8  mt-5'>
        <div className="form-check">
          <input 
          className="form-check-input" 
          type="checkbox" 
          onClick={() => handlerIsSwitchPassWord()} 
          />
          <label className="form-check-label" style={{fontSize: '14px'}} htmlFor="flexSwitchCheckChecked">
            ¿Este trámite es por medio de trasporte de Naviera?
          </label>
        </div>
        </div>
        } 
        
        {showDragZone  &&
          <div className="col-10 mt-5">
          <FileUploader
          setFile={(file)=>{
            props.setFieldValue("archivo_eir", file);
          }}
          idSolicitud={idSolicitud} 
          idContenedor={idContenedor} 
          token={token}
        />
        </div>
        }
      </div>
        <div className="row d-flex justify-content-center">
        {!isNavieraTransportation &&
          <div className="col-8 mb-4 mt-1">
            <label className="form-label">Patio de vacío</label>
            <CampoSelect
                name={"patio_vacio"}
                valores={PatioVacio}
                onChange={props.setFieldValue}
                selectedValue={props.values.patio_vacio}
                placeholder="Seleccione el patio"
              />
          </div>
        }  
          { props.values.patio_vacio?.label === 'OTROS' &&
          <div className="col-8 mb-4 mt-1">
            <label className="form-label">
              Nombre del patio de vacío
            </label>
            <Field
              type="text"
              name="otro_patio_vacio"
              className="form-control"
              id="exampleFormControlInput1"
            />
          </div>
          }
          <div className="col-8">
            <label className="form-label">
              Fecha de entrega de contenedor vacío
            </label>
            <Field
              type="date"
              name="fecha_entrega"
              className="form-control"
              id="exampleFormControlInput1"
              value={props.values.fecha_entrega}
            />
          </div>
          <div className="col-8 d-flex flex-row-reverse">
          {role === 'AGA' && 
            <button type='submit' className="btn btn-primary mt-5" disabled={props.values.archivo_eir === ""}>{dataEir.archivo_eir ? 'Guardar cambios' : 'Guardar'}</button>
          }
          </div>
        </div>
      </Form>
    )}
  </Formik>
</>
  )
}
